import { defineMessages } from "react-intl";

export const messages = defineMessages({
	title: {
		id: "form.forgotten_password",
		defaultMessage: "Elfelejtett jelszó"
	},
	help: {
		id: "form.forgotten_password.help",
		defaultMessage:
			"Kérjük adja meg email címét, mellyel rendszerünkben regisztrált."
	},
	signInLink: {
		id: "form.forgotten_password.sign_in_link",
		defaultMessage: "Bejelentkezés"
	},
	submit: {
		id: "form.forgotten_password.submit",
		defaultMessage: "Jelszó helyreállítása"
	},
	success: {
		id: "form.forgotten_password.success",
		defaultMessage: "Elküdltük az új jelszó megadásához szükséges linket!"
	}
});

export const labels = defineMessages({
	email: {
		id: "form.email",
		defaultMessage: "Email cím"
	}
});

export const errors = defineMessages({
	emailRequired: {
		id: "form.email.error.required",
		defaultMessage: "Az email cím kötelező."
	}
});
